/**
 *
 * Field
 *
 */
import NoPermissionsCard from 'app/components/NoPermissionsCard/NoPermissionsCard';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  generatePath,
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
} from 'react-router-dom';
import { RouteConstants } from '../../routes';
import { selectPermissions } from '../Authorization/slice/selectors';
import CreateOrUpdateTask from '../Task/pages/CreateOrUpdateTask/CreateOrUpdateTask';

import AddField from './pages/AddField/AddField';
import CreateField from './pages/CreateField/CreateField';
import EditField from './pages/EditField/EditField';
import FieldDetails from './pages/FieldDetails/FieldDetails';
import FieldListPage from './pages/FieldListPage/FieldListPage';

interface IProps extends RouteComponentProps {}

export function Field(props: IProps) {
  const { fieldAdministration } = useSelector(selectPermissions);
  if (fieldAdministration === 0) {
    return <NoPermissionsCard />;
  }

  return (
    <Switch>
      <Route path={RouteConstants.field.list} component={FieldListPage} />
      <Route path={RouteConstants.field.details} component={FieldDetails} />
      <Route path={RouteConstants.field.addField} component={AddField} />
      <Route path={RouteConstants.field.createField} component={CreateField} />
      <Route path={RouteConstants.field.editField} component={EditField} />

      <Route
        path={RouteConstants.field.createTaskOnField}
        component={CreateOrUpdateTask}
      />

      <Route
        exact
        path={RouteConstants.field.index}
        render={props => (
          <Redirect
            to={generatePath(RouteConstants.field.list, {
              envId: Number(props.match.params.envId),
            })}
          />
        )}
      />
    </Switch>
  );
}
